import { Component } from '@angular/core';

@Component({
  selector: 'app-account-subnav',
  templateUrl: './account-subnav.component.html',
  styleUrls: ['./account-subnav.component.scss']
})
export class AccountSubnavComponent { }
